import React from 'react';
import PropTypes from 'prop-types';

import { useApplicationState } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';

import HeaderInfoAuthorized from './HeaderInfoAuthorized';
import HeaderInfoUnauthorized from './HeaderInfoUnauthorized';
import HeaderInfoUnauthorizedSignupPage from './HeaderInfoUnautorizedSignupPage';

const { signup } = staticRoutes;

const HeaderInfo = ({
  accountDropdownTabs,
  customSignUpBtnCb,
  depositBtnLink,
  isIgnoredUnreadMessages,
  isTerminal = false,
  logoutPopupType,
  logoutRedirectLink,
}) => {
  const { authenticated, resolved } = useApplicationState();

  if (!resolved) {
    return null;
  }

  if (!authenticated) {
    return window.location.pathname === signup ? (
      <HeaderInfoUnauthorizedSignupPage />
    ) : (
      <HeaderInfoUnauthorized customSignUpBtnCb={customSignUpBtnCb} isTerminal={isTerminal} />
    );
  }

  return (
    <HeaderInfoAuthorized
      accountDropdownTabs={accountDropdownTabs}
      depositBtnLink={depositBtnLink}
      isIgnoredUnreadMessages={isIgnoredUnreadMessages}
      logoutPopupType={logoutPopupType}
      logoutRedirectLink={logoutRedirectLink}
    />
  );
};

HeaderInfo.propTypes = {
  accountDropdownTabs: PropTypes.object,
  customSignUpBtnCb: PropTypes.func,
  depositBtnLink: PropTypes.string,
  isIgnoredUnreadMessages: PropTypes.bool,
  isTerminal: PropTypes.bool,
  logoutPopupType: PropTypes.string,
  logoutRedirectLink: PropTypes.string,
};

export default HeaderInfo;
